import React from 'react';
import logo from './logo-removebg-preview.png'; 
import heroImage from './pesach.jpg';

const PassoverLanding = ({ onAdminBypass }) => {
  const storeAddress = "11608 Bd de Salaberry, Dollard-des-Ormeaux, QC H9B 2R8";
  const storePhone = "(514) 421-0421";

  return (
    <div style={{ 
      minHeight: '100vh', 
      fontFamily: "'Inter', sans-serif", 
      backgroundColor: '#f8fafc',
      display: 'flex',
      flexDirection: 'column'
    }}>
      {/* 1. New Structured Hero Section */}
      <div style={{ 
        position: 'relative', 
        height: '50vh', // Keeps the hero area 50% of screen
        // 2. The Matzah Background - Set with linear-gradient overlay
        background: `linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url(${heroImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        color: 'white',
        textAlign: 'center',
        padding: '20px'
      }}>
        {/* Logo */}
        <img 
          src={logo} 
          alt="Paradise Kosher Logo" 
          style={{ height: '120px', marginBottom: '10px', filter: 'drop-shadow(0px 4px 10px rgba(0,0,0,0.3))' }} 
        />
        
        {/* 3. Text Container - Forces text to sit higher up */}
        <div style={{ 
            marginBottom: '60px' // This pushes the text up by 60px to clear the card
        }}>
          <h1 style={{ fontSize: '3.5rem', fontWeight: '800', margin: '0', letterSpacing: '-0.02em', textShadow: '0 2px 10px rgba(0,0,0,0.5)' }}>
            Chag Pesach Sameach
          </h1>
          <p style={{ fontSize: '1.25rem', marginTop: '10px', opacity: '0.9', fontWeight: '500' }}>
            From our family at Paradise Kosher to yours.
          </p>
        </div>
      </div>

      {/* Main Content Card (The negative margin here conflicts with the text above) */}
      <div style={{ 
        maxWidth: '900px', 
        margin: '-60px auto 40px', // Pulls the card 60px UP into the hero space
        backgroundColor: 'white', 
        borderRadius: '24px', 
        padding: '40px',
        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
        position: 'relative',
        zIndex: '10', // Keeps the card in front of the background
        textAlign: 'center'
      }}>
        <h2 style={{ color: '#1e3a8a', fontSize: '2.2rem', fontWeight: '700', marginBottom: '15px' }}>
          Online Ordering is Now Closed
        </h2>
        <p style={{ color: '#4b5563', fontSize: '1.15rem', lineHeight: '1.6', marginBottom: '35px' }}>
          Our kitchen is currently at 100% capacity preparing pre-orders. <br />
          <strong>But the store is waiting for you!</strong> Visit us for a massive selection 
          of fresh, prepared-daily takeout, Seder essentials, and gourmet dishes.
        </p>

        {/* Schedule Grid */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '20px', marginBottom: '35px' }}>
          <div style={{ padding: '24px', borderRadius: '16px', backgroundColor: '#eff6ff', border: '1px solid #dbeafe' }}>
            <h3 style={{ color: '#1d4ed8', fontWeight: '700', margin: '0 0 8px 0', textTransform: 'uppercase', fontSize: '0.9rem' }}>March 31st (Tue)</h3>
            <p style={{ margin: '0', color: '#1e40af', fontSize: '1.4rem', fontWeight: '700' }}>Open until 7:00 PM</p>
            <span style={{ fontSize: '0.85rem', color: '#60a5fa' }}>Fresh kitchen restocks all day</span>
          </div>
          <div style={{ padding: '24px', borderRadius: '16px', backgroundColor: '#eff6ff', border: '1px solid #dbeafe' }}>
            <h3 style={{ color: '#1d4ed8', fontWeight: '700', margin: '0 0 8px 0', textTransform: 'uppercase', fontSize: '0.9rem' }}>April 1st (Wed)</h3>
            <p style={{ margin: '0', color: '#1e40af', fontSize: '1.4rem', fontWeight: '700' }}>Open until 3:00 PM</p>
            <span style={{ fontSize: '0.85rem', color: '#60a5fa' }}>Last call for Seder fresh-prep</span>
          </div>
        </div>

        <a 
          href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(storeAddress)}`}
          target="_blank" 
          rel="noreferrer"
          style={{ 
            display: 'inline-block', 
            backgroundColor: '#1e3a8a', 
            color: 'white', 
            padding: '18px 40px', 
            borderRadius: '14px', 
            textDecoration: 'none', 
            fontWeight: '700',
            fontSize: '1.1rem',
            boxShadow: '0 10px 15px -3px rgba(30, 58, 138, 0.3)',
            transition: 'all 0.2s'
          }}
          onMouseOver={(e) => {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.backgroundColor = '#1e40af';
          }}
          onMouseOut={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.backgroundColor = '#1e3a8a';
          }}
        >
          📍 Get Directions to the Store
        </a>
      </div>

      {/* Modern Footer */}
      <footer style={{ 
        marginTop: 'auto', 
        backgroundColor: '#0f172a', 
        color: '#f1f5f9', 
        padding: '50px 20px', 
        textAlign: 'center' 
      }}>
        <div style={{ marginBottom: '25px' }}>
          {/* Smaller logo for footer */}
          <img src={logo} alt="Paradise Kosher" style={{ height: '50px', marginBottom: '15px', opacity: '0.8' }} />
          <p style={{ opacity: '0.8', margin: '4px 0', fontSize: '1rem' }}>{storeAddress}</p>
          <p style={{ color: '#60a5fa', fontWeight: '600', margin: '4px 0', fontSize: '1.1rem' }}>{storePhone}</p>
        </div>
        <div style={{ borderTop: '1px solid #1e293b', paddingTop: '25px', fontSize: '0.85rem', opacity: '0.5' }}>
          © 2026 Paradise Kosher. All rights reserved.
        </div>
        
        <button 
          onClick={onAdminBypass}
          style={{ background: 'none', border: 'none', color: '#334155', cursor: 'pointer', marginTop: '20px', fontSize: '0.7rem' }}
        >
          Staff Portal
        </button>
      </footer>
    </div>
  );
};

export default PassoverLanding;